import { createRoutine } from 'redux-saga-routines';
const createAuthRoutine = (name) => createRoutine(`@auth/${name}`);
export const authorized = createAuthRoutine('AUTHORIZED');
export const unauthorized = createAuthRoutine('UNAUTHORIZED');
export const refreshToken = createAuthRoutine('REFRESH_TOKEN');
export const setAuthToken = createAuthRoutine('SET_AUTH_TOKEN');
export const getProductToken = createAuthRoutine('GET_PRODUCT_TOKEN');
export const login = createAuthRoutine('LOGIN');
export const logout = createAuthRoutine('LOGOUT');
export const checkTenant = createAuthRoutine('CHECK_TENANT');
export const getTenantAuth = createRoutine('GET_TENANT_AUTH');
export const editTenantAuth = createRoutine('EDIT_TENANT_AUTH');
